import styled from 'styled-components'
import colors from 'theme/colors'

export const Card = styled.div`
    background: ${colors.neutralLight};
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.07);
    box-shadow: 0 2px 12px rgba(0,0,0,0.05);
    padding: 18px;
`

export const Label = styled.p`
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0 0 14px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    color: ${colors.nightLight};
`

export const List = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 12px;
`

export const Person = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
`

export const Info = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
`

export const Name = styled.span`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: ${colors.nightDark};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

export const Pending = styled.span`
    flex-shrink: 0;
    padding: 1px 8px;
    border-radius: 999px;
    border: 1px solid #F3DFAE;
    background: #FEF3C7;
    color: #92400E;
    font-size: 11px;
    font-weight: 600;
`

export const Origin = styled.span`
    font-size: 12px;
    color: ${colors.nightLight};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`
